// Utility function to format role names - ALL service providers show as "Professional"
export const formatRole = (role) => {
  if (!role) return '';
  
  // Admin roles keep their names
  if (role === 'shop_admin') return 'Shop Admin';
  if (role === 'owner') return 'Owner';
  
  // All service providers = "Professional"
  return 'Professional';
};

// Get all available roles for dropdowns - display as specific types but label as Professional in UI
export const getAvailableRoles = () => [
  { value: 'barber', label: 'Barber' },
  { value: 'stylist', label: 'Hair Stylist' },
  { value: 'makeup_artist', label: 'Makeup Artist' },
  { value: 'nail_tech', label: 'Nail Technician' },
  { value: 'spa_beautician', label: 'Spa Beautician' },
  { value: 'esthetician', label: 'Esthetician' },
  { value: 'massage_therapist', label: 'Massage Therapist' },
  { value: 'braider', label: 'Braider' },
  { value: 'lash_technician', label: 'Lash Technician' },
  { value: 'brow_specialist', label: 'Brow Specialist' },
  { value: 'colorist', label: 'Colorist' },
  { value: 'barber_stylist', label: 'Barber Stylist' }
];
